/**
 * Camp Details Accordion
 * Transforms h3, h4, h5 headings in camp details into collapsible accordions
 * on mobile/tablet viewports (< 1400px) using native HTML details/summary elements
 */

;(function () {
  'use strict'

  /**
   * Initialize the camp details accordion functionality
   */
  function initCampDetailsAccordion() {
    const contentContainer = document.querySelector('.rd-camp-details__content')

    if (!contentContainer) {
      return
    }

    // Find all h3, h4, h5 elements inside the content container
    const headings = contentContainer.querySelectorAll('h3, h4, h5')

    if (headings.length === 0) {
      return
    }

    let isFirstAccordion = true

    // Process each heading
    headings.forEach(function (heading) {
      // Collect all sibling elements until the next heading (h3-h5) or end of container
      const content = []
      let sibling = heading.nextElementSibling

      while (sibling && !['H3', 'H4', 'H5'].includes(sibling.tagName)) {
        content.push(sibling)
        sibling = sibling.nextElementSibling
      }

      const headingTextEmpty = !(heading.textContent && heading.textContent.trim())
      const contentEmpty =
        content.length === 0 ||
        !content.some(function (el) {
          return el.textContent && el.textContent.trim()
        })

      if (headingTextEmpty && contentEmpty) {
        heading.remove()
        return;
      }

      // Create details element
      const details = document.createElement('details')
      details.className = 'rd-camp-details__accordion'

      // Create summary element and move heading inside it
      const summary = document.createElement('summary')
      summary.className = 'rd-camp-details__accordion-summary'
      summary.appendChild(heading.cloneNode(true))

      // Add arrow icon
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      svg.setAttribute('aria-hidden', 'true')
      const use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
      use.setAttributeNS(
        'http://www.w3.org/1999/xlink',
        'xlink:href',
        '#arrow-down-icon',
      )
      svg.appendChild(use)
      summary.appendChild(svg)

      // Create content wrapper
      const contentWrapper = document.createElement('div')
      contentWrapper.className = 'rd-camp-details__accordion-content'

      // Move collected elements into content wrapper
      content.forEach(function (element) {
        contentWrapper.appendChild(element)
      })

      // Build the details structure
      details.appendChild(summary)
      details.appendChild(contentWrapper)
      if (isFirstAccordion) {
        details.setAttribute('open', 'open')
        isFirstAccordion = false
      }

      // Replace the original heading with the details element
      heading.parentNode.replaceChild(details, heading)
    })
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCampDetailsAccordion)
  } else {
    // DOM is already loaded
    initCampDetailsAccordion()
  }
})()
